<template>
  <div v-if="zero.length" class="rcp-more">
    <v-icon size="16">mdi-information-outline</v-icon>
    <span v-if="ctl.showZero">{{ $t("recipes_shell.zero_shown", { n: zero.length }) }}</span>
    <span v-else>
      {{ ctl.pluralT("recipes_shell.zero_n", zero.length) }}: {{ names }}
    </span>
    <button type="button" @click="ctl.toggleZero">{{ ctl.showZero ? $t("recipes_shell.hide") : $t("recipes_shell.show") }}</button>
  </div>
</template>

<script>
/** Jela bez porcija u izabranim smjenama nisu kartice; ova napomena kaže koja su i dozvoljava da se prikažu. */
export default {
  name: "RecipesZeroNote",
  inject: { ctl: "recipesCtl" },
  computed: {
    zero() {
      return this.ctl.zeroList;
    },
    names() {
      const first = this.zero.slice(0, 2).map((c) => this.toLatin(c.name));
      const more = this.zero.length > 2 ? ` ${this.$t("recipes_shell.and_more", { n: this.zero.length - 2 })}` : "";
      return `${first.join(", ")}${more}`;
    },
  },
};
</script>
